import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import toolsRoutes from './tools'
import maintenanceRoute from './maintenance'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('@/components/template/MasterLayout'),
    children: [
      {
        path: '/',
        component: () => import('@/components/pages/HomePage'),
        name: 'home'
      }, {
        path: '/dashboard',
        component: () => import('@/components/pages/user/DashboardPage')
      }, {
        path: '/curso/:id-:slug/:class?',
        component: () => import('@/components/pages/course/CoursePage'),
        name: 'course.show'
      }, {
        path: '/lives/:id-:slug',
        component: () => import('@/components/pages/live/LivePage'),
        name: 'live.show'
      }, {
        path: '/tranks',
        component: () => import('@/components/pages/payment/SubscriptionWelcomePage'),
        name: 'subscription.success',
        meta: {
          guards: ['auth']
        }
      },

      /** Auth **/
      {
        path: '/auth/token/:token',
        component: () => import('@/components/pages/auth/AuthTokenPage')
      }, {
        path: '/recuperar-senha/:token/:email?',
        component: () => import('@/components/pages/auth/ResetPasswordPage')
      }, {
        path: '/finalizar-cadastro/:token',
        component: () => import('@/components/pages/auth/PasswordRegistrationPage'),
      },

      /** Category **/
      {
        path: '/categorias/:slug',
        component: () => import('@/components/pages/category/CategoryShowPage'),
        name: 'category.show'
      },

      /** Book **/
      {
        path: '/livros/:id-:slug',
        component: () => import('@/components/pages/book/BookPage'),
        name: 'book.show'
      },

      /** User **/
      {
        path: '/@:slug',
        component: () => import('@/components/pages/user/UserProfilePage'),
        name: 'user.profile'
      }, {
        path: '/especialista/:id',
        component: () => import('@/components/pages/user/AuthorProfilePage'),
        name: 'user.author.profile'
      }, {
        path: '/meu-perfil/:tab?',
        component: () => import('@/components/pages/user/UserAccountPage'),
        name: 'user.account',
        meta: {
          guards: ['auth']
        }
      }, {
        path: '/confirmar-dados',
        component: () => import('@/components/pages/user/UserPersonalConfirmationPage'),
        name: 'user.personal-confirmation',
        meta: {
          guards: ['auth']
        }
      }, {
        path: '/lives/premium',
        component: () => import('@/components/pages/live/PremiumLives'),
        name: 'lives.premium',
        meta: {
          guards: ['auth']
        }
      },

      {
        path: '/seja-instrutor',
        component: () => import('@/components/pages/other/become-teacher'),
        name: 'other.become-teacher'
      },

      {
        path: '/afilie-se',
        name: 'affiliate',
        beforeEnter() {
          window.location.href = 'https://sl.cyberclass.com.br/afiliados'
        }
      },

      /** Legal **/
      {
        path: '/politicas-de-privacidade',
        component: () => import('@/components/pages/legal/PrivacyPolicyPage'),
        name: 'legal.privacy'
      }, {
        path: '/termos-de-uso',
        component: () => import('@/components/pages/legal/TermsOfUsePage'),
        name: 'legal.terms'
      },

      /** Support **/
      {
        path: '/ajuda',
        component: () => import('@/components/pages/support/SupportPage'),
        name: 'support'
      },

      /** Certificate **/
      {
        path: '/certificados',
        component: () => import('@/components/pages/certificate/CertificateCheckPage'),
        name: 'certificate.check'
      },

      /** Trilha **/
      {
        path: '/trilha',
        component: () => import('@/components/pages/trail/TrailPage'),
        name: 'trail.pick',
      }, {
        path: '/minha-trilha',
        component: () => import('@/components/pages/trail/UserTrailPage'),
        name: 'trail.my',
        meta: {
          guards: ['auth']
        }
      }
    ]
  /** Layout customizado **/
  }, 
    /** Cancelamento **/
  {
    path: '/cancelamento/assinatura',
    component: () => import('@/components/pages/cancellation/CancellationSubscriptionPage'),
    name: 'cancellation.subscription',
    meta: {
      guards: ['auth']
    }
  }, {
    path: '/assinar/blackfriday',
    component: () => import('@/components/pages/landing/LandingBlackFridayPage'),
    name: 'subscribe.blackfriday'
  }, {
    path: '/assinar/:plan?',
    // component: () => import('@/components/pages/landing/LandingPage'),
    name: 'subscribe',
    meta: {
      guards: ['noSubscriber']
    },
    beforeEnter() {
      window.location.href = 'https://cyberclass.info';
    }
  },

  /** 404 */
  {
    path: "*",
    component: () => import('@/components/template/MasterLayout'),
    children: [
      { path: '/', component: () => import('@/components/pages/404Page')}
    ]
  }
]
const router = new VueRouter({
  routes: [maintenanceRoute, ...toolsRoutes, ...routes],
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  mode: 'history'
})

router.beforeEach(async (to, from, next) => {
  const isMaintenanceMode = process.env.VUE_APP_MAINTENANCE_MODE === 'true';

  if (isMaintenanceMode && to.name !== 'maintenance') {
    return next({ name: 'maintenance' });
  }

  if (to.name !== 'user.personal-confirmation' && store.getters['user/isLogged'] && !store.getters['user/user'].is_personal_infos_filled) {
    return next({ name: 'user.personal-confirmation'})
  }

  if (to.name === 'course.show') {
    window.location.href = `${process.env.VUE_APP_V2_APP_URL}${to.path}`
    return null
  }

  if (to.meta && to.meta.guards && to.meta.guards.includes('noSubscriber') && store.getters['user/isLogged']) {
    // await store.dispatch('subscription/fetchMySubscription')

    // if (store.getters['subscription/subscriptionHasAccess']) {
    //   return next({name: 'home'})
    // }
  }

  if (to.meta && to.meta.guards && to.meta.guards.includes('auth') && !store.getters['user/isLogged']) {
    return next({name: 'home'})
  }

  next()
})

export default router
